import React from "react";
import { Button, Menu } from "antd";
import { Dropdown } from 'flowbite-react';
import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import { VscGitStashApply } from "react-icons/vsc";
import { FaClockRotateLeft } from "react-icons/fa6";
import useInventoryAdjustmentAPI from "../apis/inventoryAdjustmentAPI";



const ActionColumn = (_, record, isEditing, save, edit, cancel, remove, onClick, handlenavigate) => {
  const editable = isEditing(record);
  // const { update } = useInventoryAdjustmentAPI();
  const handleClick = (e) => {
    console.log('CLICK: ', e);
  }


  return editable ? (
    <span>
      <Button
        type="text"
        icon={<SaveOutlined />}
        onClick={() => save(record)}
        style={{ marginRight: 8 }}
      >Save</Button>
      {/* <Popconfirm title="Sure to cancel?" onConfirm={cancel}> */}
        <Button type="text" icon={<CloseOutlined />} onClick={cancel}>Close</Button>
      {/* </Popconfirm> */}
    </span>
  ) : (
    <>
      {record.status !== 'save' && <Button
        type={'text'}
        onClick={() => edit(record)}
        icon={<EditOutlined />}
        className="mr-3"  
      >Edit</Button>}

      <>{<Button type="text" onClick={()=>handlenavigate(record)} icon={<FaClockRotateLeft />} className="mr-2">History</Button>}
      {record.status === 'save' && <Button type="text" onClick={()=>onClick(record)} icon={<VscGitStashApply />} className="mr-2">Apply</Button>}
      </>
      {record.status === 'save' && <Button
        type="text"
        danger
        onClick={() => {
          record['event'] = 'CLEAR';
          save(record);
        }}
        icon={<CloseOutlined />}
      >Clear</Button>}
      {/* <Button
        type="primary"
        danger  
        onClick={() => remove(record)}
        icon={<DeleteOutlined />}
      >Delete</Button> */}

    </>
  );
};


export default ActionColumn;